import { useClientState } from '../client/state';

export const useClientRoute = defineStore('repo.client.route', () => {
    const { page } = storeToRefs(useClientState());

    const path = ref(null);
    const headers = ref({});
    const options = ref({});

    const {
        execute,
        refresh,
        data,
        status,
        error
    } = useFetch(path, {
        retry: 0,
        baseURL: '/api/content',
        method: 'GET',
        headers: headers,
        immediate: false,
        watch: false,
        data: options
    });

    useErrorWatcher(status, error, options, () => page.value = null);

    const route = {
        execute: async (to: object, from: object, url: string, opts?: any) => {
            headers.value = {
                Accept: "application/json",
                "Cache-Control": "no-cache",
                'X-Requested-With': 'pipeline-client-2', // XMLHttpRequest
                ...opts?.headers
            };

            opts = { to, from, ...opts };
            options.value = (({ headers, ...o }) => o)(opts);
            path.value = url;

            await execute();

            page.value = data.value;
        },
        refresh: async () => {
            await refresh();

            page.value = data.value;
        }
    }
    
    return {
        route
    };
});